module.exports = __webpack_public_path__ + "static/media/girl-15.cf4905a7.svg";